import { supabase } from '@/integrations/supabase/client';
import type { Database } from '@/integrations/supabase/types';
import { useQuery } from '@tanstack/react-query';

type Parceiro = Database['public']['Tables']['parceiros']['Row'];


const Footer = () => {
  // Buscar parceiros do banco de dados
  const { data: parceiros = [] } = useQuery({
    queryKey: ['parceiros-footer'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('parceiros')
        .select('*')
        .eq('ativo', true)
        .order('ordem', { ascending: true })
        .limit(8); // Limitar a 8 parceiros para o footer

      if (error) {
        console.error('Erro ao carregar parceiros:', error);
        return [];
      }
      return data as Parceiro[];
    },
  });

  const siteMap = [
    { label: "Início", href: "/" },
    { label: "Programas", href: "/projetos" },
    { label: "Publicações", href: "/publicacoes" },
    { label: "CTECNOs", href: "/ctecnos" },
    { label: "Mídias", href: "/comunicacao/midias" },
    // { label: "Transparência", href: "/transparencia" },
    { label: "Comitê Gestor", href: "/comite-gestor" },
  ];

  return (
    <footer className="bg-[#6fa51e] text-white mt-20 -mx-4 md:-mx-8 lg:-mx-16 xl:-mx-80">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          {/* Column 1: Site Map */}
          <div>
            <h3 className="font-bold text-lg mb-4">Mapa do Site</h3>
            <ul className="space-y-2">
              {siteMap.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/80 hover:text-secondary transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2: Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contato</h3>
            <div className="space-y-2 text-white/80">
              <p>Edifício Cloves Vettorato - R. Eng. Edgar Prado Arze, 1.777 </p>
              <p>Centro Político Administrativo, Cuiabá - MT</p>
              <p>CEP: 78049-932</p>
              <p className="mt-4">
                <strong>Telefone:</strong> (65) 3644-4215
              </p>
              <p>
                <strong>E-mail:</strong> <a href="mailto:iagro@iagromt.com.br" className="text-white/80 hover:text-secondary transition-colors">iagro@iagromt.com.br</a>
              </p>
              <p className="mt-4">
                <strong>Horário:</strong> Seg-Sex: 07:30h às 17:30h
              </p>
            </div>
          </div>

          {/* Column 3: Partners */}
          <div>
            <h3 className="font-bold text-lg mb-4">Parceiros</h3>
            <div className="grid grid-cols-2 gap-3">
              {parceiros.map((parceiro) => (
                <div key={parceiro.id}>
                  {parceiro.website ? (
                    <a
                      href={parceiro.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white rounded p-3 flex items-center justify-center hover:bg-secondary transition-colors h-16"
                      title={`Visitar site de ${parceiro.nome}`}
                    >
                      {parceiro.logo_url ? (
                        <img
                          src={parceiro.logo_url}
                          alt={parceiro.nome}
                          className="max-w-full max-h-full object-contain"
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.style.display = 'none';
                            target.nextElementSibling?.classList.remove('hidden');
                          }}
                        />
                      ) : null}
                      <span className="text-primary font-bold text-xs text-center hidden">
                        {parceiro.nome}
                      </span>
                    </a>
                  ) : (
                    <div className="bg-white rounded p-3 flex items-center justify-center h-16">
                      {parceiro.logo_url ? (
                        <img
                          src={parceiro.logo_url}
                          alt={parceiro.nome}
                          className="max-w-full max-h-full object-contain"
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.style.display = 'none';
                            target.nextElementSibling?.classList.remove('hidden');
                          }}
                        />
                      ) : null}
                      <span className="text-primary font-bold text-xs text-center hidden">
                        {parceiro.nome}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-primary-foreground/20 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-primary-foreground/60">
          <p>&copy; 2026 IAGRO-MT. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
